import { dateConvert } from "helpers/utils";
import type { TPeriod } from "store/periodStore";

export const STATUS_MAP: Record<number, { label: string; status: string }> = {
    0: { label: "Management.ClosedPeriod", status: "closed" },
    1: { label: "Management.OpenedPeriod", status: "opened" },
    2: { label: "Management.FuturePeriod", status: "future" },
};

export const elementsIndex = (periods: TPeriod[], activePeriod: number | undefined) =>
    periods.findIndex((elem) => elem.id === activePeriod);

export const formatDates = (period: TPeriod) => `${dateConvert(period.periodStart)} - ${dateConvert(period.periodEnd)}`;

export const groupPeriodsByYear = (periods: TPeriod[]): Map<number, TPeriod[]> => {
    const grouped = new Map<number, TPeriod[]>();
    for (const period of periods) {
        const year = new Date(period.periodStart).getUTCFullYear();
        if (!grouped.has(year)) grouped.set(year, []);
        grouped.get(year)!.push(period);
    }
    for (const [, yearPeriods] of grouped) {
        yearPeriods.sort((a, b) => {
            if (a.isActive !== b.isActive) return b.isActive - a.isActive;
            if (a.periodDuration !== b.periodDuration) return a.periodDuration - b.periodDuration;
            // Most recent period first (closed periods: latest closure / calendar end at top)
            return new Date(b.periodStart).getTime() - new Date(a.periodStart).getTime();
        });
    }
    return new Map([...grouped.entries()].sort((a, b) => b[0] - a[0]));
};
